import { E_ROUTE_OPERATION_TOOLS } from './route.types';
export const operationTool = [
    {
        path: '/operation-tool/pql-rule-management',
        name: E_ROUTE_OPERATION_TOOLS.OPERATION_PQL_RULE_MANAGEMENT,
        component: () => import(/* webpackChunkName: "pqlRuleManagement" */ '../../views/operation-tool/PqlRuleManagement/PqlRuleManagement.vue'),
        meta: {
            breadcrumb: [
                {
                    text: 'backoffice.nav.operation_tool',
                },
                {
                    text: 'backoffice.nav.operation_management',
                },
                {
                    text: 'backoffice.nav.ruleManagement',
                    active: true,
                }
            ],
            permission: 'PqlRuleManagement',
        },
        children: [
            {
                path: ':product_id',
                name: E_ROUTE_OPERATION_TOOLS.OPERATION_PQL_RULE_MANAGEMENT_NAV,
                props: true,
                component: () => import(/* webpackChunkName: "pqlRuleManagementNav" */ '../../views/operation-tool/PqlRuleManagement/PqlRuleManagementNav.vue'),
                meta: {
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.operation_tool',
                        },
                        {
                            text: 'backoffice.nav.operation_management',
                        },
                        {
                            text: 'backoffice.nav.ruleManagement',
                            active: true,
                        }
                    ],
                    permission: 'PqlRuleManagement',
                },
            }, {
                path: ':product_id/dataAnalysis',
                name: E_ROUTE_OPERATION_TOOLS.OPERATION_PQL_RULE_MANAGEMENT_ANALYSIS,
                props: true,
                component: () => import(/* webpackChunkName: "pqlRuleManagementAnalysis" */ '../../views/operation-tool/PqlRuleManagement/PqlRuleManagementAnalysis.vue'),
                meta: {
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.operation_tool',
                        },
                        {
                            text: 'backoffice.nav.operation_management',
                        },
                        {
                            text: 'backoffice.nav.ruleManagement',
                            to: { name: E_ROUTE_OPERATION_TOOLS.OPERATION_PQL_RULE_MANAGEMENT_NAV },
                        },
                        {
                            text: 'backoffice.nav.data_analysis',
                            active: true,
                        }
                    ],
                    permission: 'PqlRuleManagement',
                },
            }
        ],
    },
    {
        path: '/operation-tool/product-resource-space-management',
        name: E_ROUTE_OPERATION_TOOLS.PRODUCT_RESOURCE_SPACE_MANAGEMENT,
        component: () => import(/* webpackChunkName: "productResourceSpaceManagement" */ '../../views/operation-tool/ProductResourceSpaceManagement/ProductResourceSpaceManagement.vue'),
        meta: {
            breadcrumb: [
                {
                    // $t('backoffice.nav.productResourceSpaceManagement')
                    text: 'backoffice.nav.operationManagement',
                    active: true,
                }
            ],
            permission: 'ProductResourceSpaceManagement',
        },
        children: [
            {
                path: ':product_id',
                name: E_ROUTE_OPERATION_TOOLS.PRODUCT_RESOURCE_SPACE_MANAGEMENT_NAV,
                props: true,
                redirect: {
                    name: E_ROUTE_OPERATION_TOOLS.PRODUCT_RESOURCE_SPACE_MANAGEMENT_CONTENT,
                },
                component: () => import(/* webpackChunkName: "productResourceSpaceNav" */ '../../views/operation-tool/ProductResourceSpaceManagement/ProductResourceSpaceNav/ProductResourceSpaceNav.vue'),
                meta: {
                    breadcrumb: [
                        {
                            // $t('backoffice.nav.productResourceSpaceManagement')
                            text: 'backoffice.nav.productResourceSpaceManagement',
                        }
                    ],
                    permission: 'ProductResourceSpaceManagement',
                },
                children: [
                    {
                        path: 'content',
                        name: E_ROUTE_OPERATION_TOOLS.PRODUCT_RESOURCE_SPACE_MANAGEMENT_CONTENT,
                        props: true,
                        component: () => import(/* webpackChunkName: "productResourceSpaceContent" */ '../../views/operation-tool/ProductResourceSpaceManagement/ProductResourceSpaceContent/ProductResourceSpaceContent.vue'),
                        meta: {
                            breadcrumb: [
                                {
                                    text: 'backoffice.nav.operationManagement',
                                },
                                {
                                    text: 'backoffice.nav.productResourceSpaceManagement',
                                    active: true,
                                }
                            ],
                            permission: 'ProductResourceSpaceManagement',
                        },
                    },
                    {
                        path: 'resource-space',
                        name: E_ROUTE_OPERATION_TOOLS.PRODUCT_RESOURCE_SPACE_MANAGEMENT_RESOURCE_SPACE,
                        props: true,
                        component: () => import(/* webpackChunkName: "productResourceSpace" */ '../../views/operation-tool/ProductResourceSpaceManagement/ProductResourceSpace/ProductResourceSpace.vue'),
                        meta: {
                            breadcrumb: [
                                {
                                    text: 'backoffice.nav.operationManagement',
                                },
                                {
                                    // t('backoffice.nav.productResourceSpaceManagement')
                                    text: 'backoffice.nav.productResourceSpaceManagement',
                                    active: true,
                                }
                            ],
                            permission: 'ProductResourceSpaceManagement',
                        },
                    }
                ],
            },
            {
                path: ':product_id/content-add',
                name: E_ROUTE_OPERATION_TOOLS.PRODUCT_RESOURCE_SPACE_MANAGEMENT_CONTENT_ADD,
                props: true,
                component: () => import(/* webpackChunkName: "productResourceSpaceContentEdit" */ '../../views/operation-tool/ProductResourceSpaceManagement/ProductResourceSpaceContentEdit/ProductResourceSpaceContentEdit.vue'),
                meta: {
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.operationManagement',
                            to: { name: E_ROUTE_OPERATION_TOOLS.PRODUCT_RESOURCE_SPACE_MANAGEMENT_CONTENT },
                        },
                        {
                            text: 'backoffice.nav.productResourceSpaceManagement',
                            to: { name: E_ROUTE_OPERATION_TOOLS.PRODUCT_RESOURCE_SPACE_MANAGEMENT_CONTENT },
                        },
                        {
                            text: 'backoffice.common.create',
                            active: true,
                        }
                    ],
                    permission: 'ProductResourceSpaceManagement',
                },
            },
            {
                path: ':product_id/content-edit/:content_id',
                name: E_ROUTE_OPERATION_TOOLS.PRODUCT_RESOURCE_SPACE_MANAGEMENT_CONTENT_EDIT,
                props: true,
                component: () => import(/* webpackChunkName: "productResourceSpaceContentEdit" */ '../../views/operation-tool/ProductResourceSpaceManagement/ProductResourceSpaceContentEdit/ProductResourceSpaceContentEdit.vue'),
                meta: {
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.operationManagement',
                            to: { name: E_ROUTE_OPERATION_TOOLS.PRODUCT_RESOURCE_SPACE_MANAGEMENT_CONTENT },
                        },
                        {
                            text: 'backoffice.nav.productResourceSpaceManagement',
                            to: { name: E_ROUTE_OPERATION_TOOLS.PRODUCT_RESOURCE_SPACE_MANAGEMENT_CONTENT },
                        },
                        {
                            text: 'backoffice.common.edit',
                            active: true,
                        }
                    ],
                    permission: 'ProductResourceSpaceManagement',
                },
            },
            {
                path: ':product_id/content-detail/:content_id',
                name: E_ROUTE_OPERATION_TOOLS.PRODUCT_RESOURCE_SPACE_MANAGEMENT_CONTENT_DETAIL,
                props: true,
                component: () => import(/* webpackChunkName: "productResourceSpaceContentDetail" */ '../../views/operation-tool/ProductResourceSpaceManagement/ProductResourceSpaceContentDetail/ProductResourceSpaceContentDetail.vue'),
                redirect: {
                    name: E_ROUTE_OPERATION_TOOLS.PRODUCT_RESOURCE_SPACE_MANAGEMENT_CONTENT_DETAIL_VIEW,
                },
                meta: {
                    permission: 'ProductResourceSpaceManagement',
                },
                children: [
                    {
                        path: 'view',
                        name: E_ROUTE_OPERATION_TOOLS.PRODUCT_RESOURCE_SPACE_MANAGEMENT_CONTENT_DETAIL_VIEW,
                        component: () => import(/* webpackChunkName: "productResourceSpaceNav" */ '../../views/operation-tool/ProductResourceSpaceManagement/ProductResourceSpaceContentDetailView/ProductResourceSpaceContentDetailView.vue'),
                        props: true,
                        meta: {
                            breadcrumb: [
                                {
                                    text: 'backoffice.nav.operationManagement',
                                    to: { name: E_ROUTE_OPERATION_TOOLS.PRODUCT_RESOURCE_SPACE_MANAGEMENT_CONTENT },
                                },
                                {
                                    text: 'backoffice.nav.productResourceSpaceManagement',
                                    to: { name: E_ROUTE_OPERATION_TOOLS.PRODUCT_RESOURCE_SPACE_MANAGEMENT_CONTENT },
                                },
                                {
                                    text: 'backoffice.productResourceSpace.view',
                                    active: true,
                                }
                            ],
                            permission: 'ProductResourceSpaceManagement',
                        },
                    },
                    {
                        path: 'rule',
                        name: E_ROUTE_OPERATION_TOOLS.PRODUCT_RESOURCE_SPACE_MANAGEMENT_CONTENT_DETAIL_RULE,
                        props: true,
                        component: () => import(/* webpackChunkName: "productResourceSpaceNav" */ '../../views/operation-tool/ProductResourceSpaceManagement/ProductResourceSpaceContentDetailRule/ProductResourceSpaceContentDetailRule.vue'),
                        meta: {
                            breadcrumb: [
                                {
                                    text: 'backoffice.nav.operationManagement',
                                    to: { name: E_ROUTE_OPERATION_TOOLS.PRODUCT_RESOURCE_SPACE_MANAGEMENT_CONTENT },
                                },
                                {
                                    text: 'backoffice.nav.productResourceSpaceManagement',
                                    to: { name: E_ROUTE_OPERATION_TOOLS.PRODUCT_RESOURCE_SPACE_MANAGEMENT_CONTENT },
                                },
                                {
                                    text: 'backoffice.productResourceSpace.rule',
                                    active: true,
                                }
                            ],
                            permission: 'ProductResourceSpaceManagement',
                        },
                    },
                    {
                        path: 'record',
                        name: E_ROUTE_OPERATION_TOOLS.PRODUCT_RESOURCE_SPACE_MANAGEMENT_CONTENT_DETAIL_RECORD,
                        props: true,
                        component: () => import(/* webpackChunkName: "productResourceSpaceNav" */ '../../views/operation-tool/ProductResourceSpaceManagement/ProductResourceSpaceContentDetailRecord/ProductResourceSpaceContentDetailRecord.vue'),
                        meta: {
                            breadcrumb: [
                                {
                                    text: 'backoffice.nav.operationManagement',
                                    to: { name: E_ROUTE_OPERATION_TOOLS.PRODUCT_RESOURCE_SPACE_MANAGEMENT_CONTENT },
                                },
                                {
                                    text: 'backoffice.nav.productResourceSpaceManagement',
                                    to: { name: E_ROUTE_OPERATION_TOOLS.PRODUCT_RESOURCE_SPACE_MANAGEMENT_CONTENT },
                                },
                                {
                                    text: 'backoffice.productResourceSpace.record',
                                    active: true,
                                }
                            ],
                            permission: 'ProductResourceSpaceManagement',
                        },
                    }
                ],
            }
        ],
    },
    {
        path: '/operation-tool/operation-promotion-link',
        name: E_ROUTE_OPERATION_TOOLS.OPERATION_PROMOTION_LINL,
        component: () => import(/* webpackChunkName: "operationPromotionPink" */ '../../views/operation-tool/OperationPromotionLink/OperationPromotionLink.vue'),
        meta: {
            breadcrumb: [
                {
                    text: 'backoffice.nav.operation_tool',
                },
                {
                    text: 'backoffice.nav.selfRegistionLink',
                },
                {
                    text: 'backoffice.operationPromotionLink.operationPromotionSelfRegisterLink',
                    active: true,
                }
            ],
            permission: 'ActivityPromotionVisible',
        },
    }
];
